"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Grant_1 = require("./_Grant");
exports._Grants = {
    type: "list",
    member: {
        shape: _Grant_1._Grant,
        locationName: "Grant"
    }
};
//# sourceMappingURL=_Grants.js.map